export const DEPARTMENTS = [
  "customer-support",
  "quality",
  "logistics",
  "warehouse",
  "finance",
];
